<template>
    <div class="table-scroll">
    <table class="table">
            <colgroup>
            <col width="50px" >
            <col>
            <col>
            <col>
            <col>
            <col width="225px">
            <col v-if="schoolsInfo.hasDistance">
            </colgroup>
        <thead>
            <tr>
                <td>Rating</td>
                <td>School name</td>
                <td>Type</td>
                <td>Grade</td>
                <td>Reviews</td>
                <td>Homes for sale nearby</td>
                <td v-if="schoolsInfo.hasDistance">Distance (mi)</td>
            </tr>
        </thead>
        <tbody>
        <tr v-for="item in schoolsInfo.list">
            <td><span class="circle" :rate="item.rating"></span></td>
            <td class="school-card-link"> <a class="link" :href="glb.appUrl + item.dspUrl">{{item.schoolName || item.name}}</a></td>
            <td class="capitalize">{{item.type}}</td>
            <td>{{item.level}}</td>
            <td>{{item.reviewCount || '-'}}</td>
            <td><a class="link" :href="item.schoolZoneUrl">View Homes</a></td>
            <td v-if="schoolsInfo.hasDistance">{{item.distance || '-'}}</td>
        </tr>
        </tbody>
    </table>
    </div>
</template>

<script src="./schools-table.js"></script>

